export default __webpack_public_path__ + "static/media/hero-level-5-chars-desk.396fac8c.webp";